export default __webpack_public_path__ + "static/media/SHARE_B.d004b9e9.png";